// ARTVERTISEMENT
if ($ === undefined) {
    var $ = jQuery;
}
// LinkScroller / Linkanker (1/3)
var url, 
	posUrlLetzteRaute,
	urlUnterSeite,
	elementID,
	scrollSpeed, 
	hinScrollen,
	adjustValue;

var windowWidth,
	windowHeight,
	documentHeight;


var overlayZU  = true;


$(document).ready(function() {
  
    bezieheDimensionen();  
  
  // LinkScroller / Linkanker einstellungen (2/3)
    scrollSpeed     = 1500;
    hinScrollen     = true; 
    adjustValue     = -0;
  
    if(windowWidth < 740){
      adjustValue  = -80;
    }
        
  
    url                = window.location.href;
    posUrlLetzteRaute  = url.lastIndexOf("#");
    urlUnterSeite      = url.slice(posUrlLetzteRaute);
  
  
   // OVERLAY
	$(".overlay-opener").click(function() {
		var overlayID = $(this).data('overid');
		openOverlay(overlayID);
		return false;
	});
  
	$(".overlayClose").click(function() {
		closeOverlay();	 
	});
  
	function openOverlay(overlayID)
	{
		if(overlayZU)
		{
			var overlayCenter = $('#'+overlayID).data('center');
			var overlayBGClass = $('#'+overlayID).data('bgclass');
			var overlayInhalt = $('#'+overlayID).find('.overlay-wrap');
			if(overlayCenter == '1') {
				$("#content-overlay").addClass('co-vcenter');
			}
			if(overlayBGClass != undefined) {
				$("#content-overlay").addClass(overlayBGClass);
			}
			$(overlayInhalt).attr('data-fromoverlay', overlayID); 
			$(overlayInhalt).appendTo( "#content-overlay" );
			
			setTimeout(function() { 
				$("#content-overlay").addClass('auf'); 
			}, 100);
			
			$("body").addClass('content-overlay_auf');
			$("html").addClass('co-stopScroll');	
			overlayZU = false;
		}		
	}
	
	function closeOverlay()
	{
		if(!overlayZU)
		{
			var overlayWrap = $('#content-overlay .overlay-wrap')
			var fromOverlayID = overlayWrap.data('fromoverlay');
			overlayWrap.appendTo( "#"+fromOverlayID );
			$("#content-overlay").removeClass('auf hell dunkel blur vcenter');
			$("body").removeClass('content-overlay_auf');
			$("html").removeClass('co-stopScroll');	
			overlayZU = true;
		}
	}


    // Schubladen
  	$(".weiterlesen").click(function()
  	{ 
  		var el = $(this);
      
  		// fulltext oeffnen
  		el.prev(".fulltext").slideToggle(500); 

  		// wechselt beim Klick von "" zu "auf". 
  		el.toggleClass("auf"); 

  		// button text tauschen
		if (el.text() == el.data("text-swap")) { // schublade schliessen 
			
			el.text(el.data("text-original"));

			// zum article top 
			var schubladenOffsetTop = el.parents('.schubladenWrapp').offset().top;
			if (smartphone)
			{
				$("html, body").scrollTop( schubladenOffsetTop -90); // 90 header height
			} else {
				$("html, body").animate({ scrollTop: schubladenOffsetTop -90 }, 600);
			}

		} else { // schublade oeffnen 
			
			el.data("text-original", el.text());
			el.text(el.data("text-swap"));
		}
  	});

  // Linkanker / Linkanker - hash immer mit #! angeben (3/3)
  // einstellungen oben 
      $('.linkanker').click( function() 
      { 
          var linkHref        = $(this).attr("href");
          var posLetzteRaute  = linkHref.lastIndexOf("#");
          var linkanker       = linkHref.slice(posLetzteRaute);
              elementID       = linkanker.substr(1);  // #! entfernen
         
          var aktuelleSeite       = '';
          var neueVerlinkung      = ''; // immer gleich es sei denn externe link  
          if (linkHref.match('/')) { 
              var aktuelleSeite       = window.location.pathname;
              var aktuelleSeiteLength = aktuelleSeite.length; // anzahl der buchstaben
              var neueVerlinkung      = linkHref.substr(0, aktuelleSeiteLength); // #!elementID entfernen
          }
console.log(adjustValue);
        console.log(adjustValue);

          if(aktuelleSeite == neueVerlinkung)
          {
              if (document.getElementById(elementID)) {
                  if(hinScrollen == true)
                      $("html, body").animate({ scrollTop: $('#' + elementID).offset().top + adjustValue }, scrollSpeed ); // animiere
                  else
                      $('html, body').scrollTop($('#' + elementID).offset().top + adjustValue ); // springen
              } else {
                  if(hinScrollen == true)
                      $("html, body").animate({ scrollTop: 0 }, scrollSpeed);
                  else
                      $('html, body').scrollTop(0);
              }
              return false;
          }
      });
});

$(window).resize(function() {  
    bezieheDimensionen();    
});

function bezieheDimensionen() 
{
    windowWidth = $(window).width();
    windowHeight = $(window).height();
}
	